import { render, staticRenderFns } from "./TemplateTwo.vue?vue&type=template&id=e99c9728&scoped=true&"
import script from "./TemplateTwo.vue?vue&type=script&lang=js&"
export * from "./TemplateTwo.vue?vue&type=script&lang=js&"
import style0 from "./TemplateTwo.vue?vue&type=style&index=0&id=e99c9728&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99c9728",
  null
  
)

export default component.exports